(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('CustomFieldDefinitionFormController', CustomFieldDefinitionFormController);

  /* ngInject */
  function CustomFieldDefinitionFormController($state, $stateParams, Flash, customFieldDefinitionService, sessionService) {
    const vm = this;

    vm.customFieldDefinition = {};
    vm.deleteCustomFieldDefinition = deleteCustomFieldDefinition;
    vm.id = $stateParams.id;
    vm.saveCustomFieldDefinition = saveCustomFieldDefinition;

    activate();

    function activate() {
      if (vm.id) {
        getCustomFieldDefinition();
      }
    }

    function deleteCustomFieldDefinition() {
      customFieldDefinitionService(sessionService.getAuthToken()).destroy({ id: vm.id }, _ => {
        $state.go('application.vms.custom_field_definitions', {});
        Flash.create('success', 'Custom field successfully deleted.');
        angular.element('#deleteCustomFieldModal').modal('hide');
      },
      _ => {
        Flash.create('danger', 'An error occurred with the submission. Please try again later.');
      });
    }

    function getCustomFieldDefinition() {
      customFieldDefinitionService(sessionService.getAuthToken()).get({id: vm.id}, response => vm.customFieldDefinition = response);
    }

    function saveCustomFieldDefinition() {
      if (vm.id) {
        customFieldDefinitionService(sessionService.getAuthToken()).update({ id: vm.id }, vm.customFieldDefinition,
          _ => {
            $state.go('application.vms.custom_field_definitions', {});
            Flash.create('success', 'Custom field definition successfully updated.');
          },
          _ => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
          }
        );
      } else {
        customFieldDefinitionService(sessionService.getAuthToken()).create({}, vm.customFieldDefinition,
          _ => {
            $state.go('application.vms.custom_field_definitions', {});
            Flash.create('success', 'Custom field definition successfully created.');
          },
          _ => {
            Flash.create('danger', 'An error occurred with the submission. Please correct the following errors on the form and resubmit.'); 
          }
        );
      }
    }
  }
})();
